import toastMessage from "../toastMessage";
import { getStorage } from "../storage";
import api from "../api";

const API_URL = process.env.REACT_APP_BBMS_BASE_API;

const fetchBloodCollectionDailyPlan = async (lng = "english", params = {}) => {
  try {
    const user = await getStorage();
    const res = await api({
      method: "GET",
      url: `${API_URL}/bloodCollectionDailyPlan`,
      params,
      headers: { Authorization: `Bearer ${user.token}` },
    });
    return res.data;
  } catch (error) {
    toastMessage("error", "Unable to fetch daily collection plan");
  }
};

export const createBloodCollectionDailyPlan = async (lng = "english", body) => {
  const user = await getStorage();
  return api({
    method: "POST",
    url: `${API_URL}/bloodCollectionDailyPlan`,
    data: body,
    headers: { Authorization: `Bearer ${user.token}` },
  });
};

export const bulkCreateBloodCollectionDailyPlan = async (
  lng = "english",
  entries
) => {
  const user = await getStorage();
  return api({
    method: "POST",
    url: `${API_URL}/bloodCollectionDailyPlan/bulk`,
    data: { entries },
    headers: { Authorization: `Bearer ${user.token}` },
  });
};

export const updateBloodCollectionDailyPlan = async (lng = "english", body) => {
  const user = await getStorage();
  return api({
    method: "PUT",
    url: `${API_URL}/bloodCollectionDailyPlan`,
    data: body,
    headers: { Authorization: `Bearer ${user.token}` },
  });
};

export const deleteBloodCollectionDailyPlan = async (lng = "english", id) => {
  const user = await getStorage();
  return api({
    method: "DELETE",
    url: `${API_URL}/bloodCollectionDailyPlan`,
    data: { id },
    headers: { Authorization: `Bearer ${user.token}` },
  });
};

export default fetchBloodCollectionDailyPlan;
